import { axiosApi } from "../../../../../api/dbAxios";
import { IPreferredFilter } from "../interfaces/userSettingsFilters.interface";

export const updateUserSettings = async (prefFilters: IPreferredFilter) => {
  const body: Record<string, any> = {};

  Object.entries(prefFilters).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      !(Array.isArray(value) && value.length === 0) &&
      !(typeof value === "string" && value.trim() === "")
    ) {
      body[key] = value;
    }
  });

  try {
    const response = await axiosApi.post(`/settings/`, body);
    return response.data;
  } catch (error) {
    console.error("Error updating user settings:", error);
    return [];
  }
};
